<div style="overflow: inherit; position: relative;">
<h2 mat-dialog-title mat-dialog-draggable-title style="position: absolute; right: 0; margin-bottom: 0px !important; display: flow-root;">
  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<div class="row" style="display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding-right: 12px;">
  <div class="col-2 pr-0" style="font-size: 18px; font-weight: 700; display: contents;">
    <div style="padding-bottom: 20px;">
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#FDE6EB"/>
    <path d="M24 20V24M24 28H24.01M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z" stroke="#EE0033" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    </div>
    {{'alert.notification' | translate}}
  </div>
  <div class="col-12 pr-0">
    <div [innerHTML]="safeMessage" style=" padding: 0px !important; overflow-wrap: break-word; font-size: 14px; font-weight: 400; height: 137px;"></div>
  </div>
</div>


<div mat-dialog-actions class="justify-content-center" style="padding: 32px 0px 0px 0px; gap: 6px;">

  <!--build icon, set default cancel-->
  <button style="width: 202.5px; background-color: white;" mat-stroked-button color="primary" type="button" (click)="onNoClick()" cdkFocusInitial>
        {{'button.cancel_2' | translate}}
  </button>
  <button style="width: 202.5px;" mat-raised-button color="primary" [mat-dialog-close]="true">
        {{'button.signAuthen' | translate}}
  </button>
</div>
</div>